import { useSelector } from "react-redux";
import { Box } from "@material-ui/core";
import { useStyles } from "../../style";
import { RootState } from "../../../../Redux/Store/type";
import { BULK_UPLOAD_STATUS_VIEW } from "../../../../Constants/bulkUpload";
import GSTItemsUploadingModal from "./GSTItemsUploadingModal";
import GreenCheckIcon from "../../../../Assets/images/green-check-icon.svg";
import DownloadIcon from "../../../../Assets/images/download-btn-icon.svg";
import ExcelIcon from "../../../../Assets/images/excel-icon.svg";
import ExclamationIcon from "../../../../Assets/images/red-exclamation-icon.svg";

interface Props {
  onFileChange: (e: any) => void;
  showItemsUploadingModal: boolean;
  handleClose: () => void;
  status: number;
}

const UploadGstSheetModal = ({ onFileChange, status, showItemsUploadingModal, handleClose }: Props) => {
  const classes: any = useStyles();
  const { gstBulkUploadStatusDetails } = useSelector((state: RootState) => ({
    gstBulkUploadStatusDetails: state.bulkUploadReducer.gstBulkUploadStatusDetails,
  }));

  const renderBasedOnDownloadStatus = () => {
    switch (status) {
      case BULK_UPLOAD_STATUS_VIEW.SUCCESS:
        return (
          <div className="flex flex-column justify-center items-center ds-mt68">
            <img src={GreenCheckIcon} width={64} height={64} />
            <p className="mv0 ds-pt16 fw6 md-text24">Uploaded Successfully</p>
            <Box component="p" className="mv0 ds-pt12 md-text15 fw4 ds-c797A7C tc">
              {gstBulkUploadStatusDetails?.successful_entries}/{gstBulkUploadStatusDetails?.total_entries} products
              updated. Proceed to enable GST Billing
            </Box>
            <button onClick={handleClose} className={classes.okCloseBtn}>
              Ok, Close
            </button>
          </div>
        );
      case BULK_UPLOAD_STATUS_VIEW.FAILURE:
        return (
          <div className="flex flex-column justify-center items-center ds-mt64">
            <img src={ExclamationIcon} width={64} height={64} />
            <p className="mv0 ds-pt16 fw6 md-text24">Upload Failed!</p>
            <p className="mv0 ds-pt12 md-text15 fw4 ds-c797A7C">
              {gstBulkUploadStatusDetails?.failed_entries}/{gstBulkUploadStatusDetails?.total_entries} items failed to
              upload. Issues have been mentioned in the Error
            </p>
            <p className="mv0 md-text15 fw4 ds-c797A7C">Sheet. Click to download!</p>
            <div className="ds-mt32 flex items-center justify-center">
              <label htmlFor="gst-file-upload" className="pointer">
                <div className={classes.uploadAgainBtn}>
                  <input id="gst-file-upload" type="file" accept=".xlsx, .xls, .csv" onChange={onFileChange} hidden />
                  Upload Again
                </div>
              </label>
              <a href={gstBulkUploadStatusDetails.report_file} className={classes.downloadErrorSheetBtn}>
                <img src={DownloadIcon} width="13px" height="16px" />
                <p className="mv0 ds-ml10">Error Sheet</p>
              </a>
            </div>
          </div>
        );
      default:
        return (
          <div className="flex flex-column justify-center items-center ds-mt64">
            <img src={ExcelIcon} width={64} height={64} />
            <p className="mv0 ds-pt16 fw6 md-text24">Upload catalog sheet</p>
            <p className="mv0 ds-pt12 md-text15 fw4 ds-c797A7C">
              Add HSN/SAC code in the sheet you downloaded where ever
            </p>
            <p className="mv0 md-text15 fw4 ds-c797A7C">applicable & Upload it to enable GST Billing</p>
            <label htmlFor="gst-file-upload" className="pointer">
              <div className={classes.uploadGstCatalogSheet}>
                <input id="gst-file-upload" type="file" accept=".xlsx, .xls, .csv" onChange={onFileChange} hidden />
                Upload
              </div>
            </label>
          </div>
        );
    }
  };

  const renderView = () => {
    if (showItemsUploadingModal && status === BULK_UPLOAD_STATUS_VIEW.PROCESSING) {
      return <GSTItemsUploadingModal />;
    }
    return renderBasedOnDownloadStatus();
  };
  return renderView();
};

export default UploadGstSheetModal;
